import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Redirect = ({ route }: { route: string }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(route, { replace: true });
    }, [navigate, route]);

    return null;
};
